import axiosConnect from "../../../utils/axiosConnect";
var addEditPatient = function addEditPatient(patientData, isEditMode, sourceId) {
  var url = "/patients/".concat(sourceId, "/create/");
  if (isEditMode && patientData !== null && patientData !== void 0 && patientData.patient_uid) {
    url = "/patients/".concat(patientData === null || patientData === void 0 ? void 0 : patientData.patient_uid, "/");
  }
  return axiosConnect.post(url, patientData).then(function (res) {
    return res;
  })["catch"](function (err) {
    console.error(err);
  });
};
export default addEditPatient;